export const getBear = (bear, props) => ({
  ...props.drawer.items.find(item => item.type === bear.type),
  name: bear.name,
});



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/BearFam/helpers.js